interface PostHeaderProps {
  title: string;
  description: string;
  keywords: string;
  author: string;
  canonicalUrl: string;
  image?: string;
  datePublished?: string;
  dateModified?: string;
}

export function PostHeader(_props: PostHeaderProps) {
  return null;
}
